/**
 * Directives for module mwApp.sets
 */

/**
 * notInArray directive <br>
 * Check value of input against array values
 *
 * @class notInArray
 * @memberof mwApp/sets
 * @see mwApp/sets
 *
 * @ngdoc directive
 * @name mwApp/sets.directive:notInArray
 */
/* @ngInject */
export function notInArray () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      notInArray: '='
    },
    link: function (scope, _element, _attributes, ngModel) {
      // watch by length type to validate field again
      // scope.$watch('notInArray', function(newValue) {
      //     if (newValue) {
      //         ngModel.$validate();
      //     }
      // });

      // check subscription max length
      ngModel.$validators.notInArray = function (modelValue, viewValue) {
        var value = modelValue || viewValue
        return !(scope.notInArray && scope.notInArray.length && scope.notInArray.indexOf(value) > -1)
      }
    }
  }
}
